// extracted by mini-css-extract-plugin
export default {"userDelete":"T2DwiyDCXod4i2YUQaX76w=="};